import ENV from './config';
export default {
  ...ENV
};
